import React from 'react'
import { Modal } from 'react-bootstrap'
import './AloModal.scss'
import PropTypes from 'prop-types'

const AloModal = ({ children, className, ...props }) => {
  return (
    <Modal {...props} className={`AloModal ${className}`}>
      <button className='close' onClick={props.onHide}>
        &times;
      </button>
      {children}
    </Modal>
  )
}

AloModal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onHide: PropTypes.func
}

export default AloModal
